// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row .col label {
  color: #4b58a6;
  font-weight: bold;
  padding-right: 3%;
}
h2 {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
  align-items: center;
}
.no-fraud {
  font-weight: 600;
  text-align: center;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
img.overlay {
  /* height: 900px; */
  width: 99%;
  box-shadow: 1px 2px 3px #89889c;
  border: 2px solid rgba(25, 4, 101, 0.31);
}
button {
  border-radius: 0;
  border: 1px solid rgba(128, 0, 128, 0.31);
}
button.overlays {
  background-color: rgba(247, 173, 67, 0.76);
}
div.alert {
  border-radius: 0 !important;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/income-stream-components/paystub-upload/paystub-upload.component.less"],"names":[],"mappings":"AAGA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;AAIA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;AAKA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;AAHJ;AAMA;EAJE,mBAAmB;EAMjB,UAAA;EACA,+BAAA;EACA,wCAAA;AAJJ;AAQA;EACI,gBAAA;EACA,yCAAA;AANJ;AAOI;EACI,0CAAA;AALR;AASA;EACK,2BAAA;EACD,kBAAA;AAPJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n\n\n.row .col label{\n    color: #4b58a6;\n    font-weight: bold;\n    padding-right: 3%;\n}\nh2{\n    background: #e1dbe2;\n    margin:0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.no-fraud{\n    font-weight: 600;\n    text-align: center;\n    padding: 5px;\n    border: 1px solid rgba(0, 0, 0, .1);\n}\n\nimg.overlay{\n    /* height: 900px; */\n    width: 99%;\n    box-shadow: 1px 2px 3px #89889c;\n    border: 2px solid rgba(25,4, 101, 0.31);\n    \n}\n\nbutton {\n    border-radius: 0;\n    border: 1px solid rgba(128,0,128,0.31);\n    &.overlays{\n        background-color: rgba(247,173,67,0.76);\n    }\n}\n\ndiv.alert{\n     border-radius: 0 !important;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
